import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { uid } from 'uid'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import { HiPhone } from 'react-icons/hi'
import './Restaurant.css'

const Restaurant = ({ restaurant }) => {
  const [displayDetails, setDisplayDetails] = useState(false)

  const {
    name,
    address1,
    city,
    state,
    zip,
    lat,
    long,
    telephone,
    website,
    hours,
    attire,
    tagsArray,
    genreArray,
  } = restaurant

  const genres = genreArray.map((genre) => (
    <li key={uid()} className='genres-item'>
      {genre}
    </li>
  ))

  const tags = tagsArray.map((tag) => (
    <li key={uid()} className='tags-item'>
      {`# ${tag}`}
    </li>
  ))

  return (
    <section className='restaurant-container'>
      <section className='default-restaurant-info-container'>
        <section className='default-restaurant-main-info'>
          <p>{name}</p>
          <p>{`${city} , ${state}`}</p>
          <p className='phone-number-wrapper'>
            <HiPhone /> {`+1 ${telephone}`}
          </p>
        </section>

        <ul className='genres-list'>{genres}</ul>
      </section>

      <button
        className='display-details-button'
        onClick={() => setDisplayDetails(!displayDetails)}
      >
        {displayDetails ? (
          <IoIosArrowUp className='display-details-icon' />
        ) : (
          <IoIosArrowDown className='display-details-icon' />
        )}
      </button>

      <section
        className={
          displayDetails ? 'extra-restaurant-info-container' : 'hidden'
        }
      >
        <p className='extra-restaurant-info-item'>{`${address1} ${city} ${state} ${zip}`}</p>
        <p className='extra-restaurant-info-item'>{hours}</p>
        <a
          className='extra-restaurant-info-item'
          href={website}
          target='_blank'
        >
          {website}
        </a>
        <ul className='tags-list'>{tags}</ul>
        <section className='attire-list'>
          <p className='attire-item'>{attire}</p>
        </section>
      </section>
    </section>
  )
}

export default Restaurant

Restaurant.prototypes = {
  restaurant: PropTypes.object,
}
